import Arbor from "@/pages/catalogs/pages/arbors";
import Carrier from "@/pages/catalogs/pages/carriers";
import CassetteChock from "@/pages/catalogs/pages/cassette-chocks";
import Cassette from "@/pages/catalogs/pages/cassettes";
import Chock from "@/pages/catalogs/pages/chocks";
import Donut from "@/pages/catalogs/pages/donuts";
import EdgerRoll from "@/pages/catalogs/pages/edger-rolls";
import Guide from "@/pages/catalogs/pages/guides";
import UniversalRoll from "@/pages/catalogs/pages/universal-roll";

export const routeArbor = "/catalogs/arbors";
export const routeDonut = "/catalogs/donuts";
export const routeUniversalRoll = "/catalogs/universal-rolls";
export const routeEdgerRoll = "/catalogs/edger-rolls";
export const routeCarrier = "/catalogs/carriers";
export const routeCassette = "/catalogs/cassettes";
export const routeChock = "/catalogs/chocks";
export const routeCassetteChock = "/catalogs/cassette-chocks";
export const routeGuide = "/catalogs/guides";
export const catalogsArborsPermission = "ui.navbar.catalogs.arbors";
export const catalogsCarriersPermission = "ui.navbar.catalogs.carriers";
export const catalogsCassetteChocksPermission =
	"ui.navbar.catalogs.cassette.chocks";
export const catalogsCassettesPermission = "ui.navbar.catalogs.cassettes";
export const catalogsChocksPermission = "ui.navbar.catalogs.chocks";
export const catalogsDonutsPermission = "ui.navbar.catalogs.donuts";
export const catalogsEdgerRollsPermission = "ui.navbar.catalogs.edger.rolls";
export const catalogsGuidesPermission = "ui.navbar.catalogs.guides";
export const catalogsUniversalRollsPermission =
	"ui.navbar.catalogs.universal.rolls";

export const catalogRoutes = [
	{
		path: `${routeArbor}`,
		element: <Arbor />,
		permission: catalogsArborsPermission,
	},
	{
		path: `${routeArbor}/:partId`,
		element: <Arbor />,
		permission: catalogsArborsPermission,
	},
	{
		path: `${routeDonut}`,
		element: <Donut />,
		permission: catalogsDonutsPermission,
	},
	{
		path: `${routeDonut}/:partId`,
		element: <Donut />,
		permission: catalogsDonutsPermission,
	},
	{
		path: `${routeUniversalRoll}`,
		element: <UniversalRoll />,
		permission: catalogsUniversalRollsPermission,
	},
	{
		path: `${routeUniversalRoll}/:partId`,
		element: <UniversalRoll />,
		permission: catalogsUniversalRollsPermission,
	},
	{
		path: `${routeEdgerRoll}`,
		element: <EdgerRoll />,
		permission: catalogsEdgerRollsPermission,
	},
	{
		path: `${routeEdgerRoll}/:partId`,
		element: <EdgerRoll />,
		permission: catalogsEdgerRollsPermission,
	},
	{
		path: `${routeCarrier}`,
		element: <Carrier />,
		permission: catalogsCarriersPermission,
	},
	{
		path: `${routeCarrier}/:partId`,
		element: <Carrier />,
		permission: catalogsCarriersPermission,
	},
	{
		path: `${routeCassette}`,
		element: <Cassette />,
		permission: catalogsCassettesPermission,
	},
	{
		path: `${routeCassette}/:partId`,
		element: <Cassette />,
		permission: catalogsCassettesPermission,
	},
	{
		path: `${routeChock}`,
		element: <Chock />,
		permission: catalogsChocksPermission,
	},
	{
		path: `${routeChock}/:partId`,
		element: <Chock />,
		permission: catalogsChocksPermission,
	},
	{
		path: `${routeCassetteChock}`,
		element: <CassetteChock />,
		permission: catalogsCassetteChocksPermission,
	},
	{
		path: `${routeCassetteChock}/:partId`,
		element: <CassetteChock />,
		permission: catalogsCassetteChocksPermission,
	},
	{
		path: `${routeGuide}`,
		element: <Guide />,
		permission: catalogsGuidesPermission,
	},
	{
		path: `${routeGuide}/:partId`,
		element: <Guide />,
		permission: catalogsGuidesPermission,
	},
];
